"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModernStructuredMessage;
var _react = _interopRequireWildcard(require("react"));
var _AssistantProvider = require("./AssistantProvider");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getApiUrl = () => process.env.REACT_APP_CHAT_AGENT_DOMAIN || 'http://localhost:8080';
const isMockEnabled = () => process.env.REACT_APP_DEVELOPMENT_MODE === 'enabled';
function getDecisionHeaders() {
  const headers = process.env.REACT_APP_TEAM ? {
    team: process.env.REACT_APP_TEAM
  } : {};
  const userKey = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".LastAuthUser"));
  if (!userKey) {
    return headers;
  }
  const jwt = localStorage.getItem("CognitoIdentityServiceProvider.".concat(process.env.REACT_APP_USER_POOL_CLIENT_ID, ".").concat(userKey, ".idToken"));
  if (jwt) {
    headers.Authorization = "Bearer ".concat(jwt);
  }
  return headers;
}
const isValidTarget = target => /^([^|\s]+)\|([^|\s]+)$/.test(target);
const TICKET_REF_LABELS = {
  ref1_source_system: 'Source System',
  ref2_issue: 'Issue',
  ref3_data_source: 'Data Source',
  ref4_eid: 'EID'
};
function formatOperationLabel(operation) {
  if (!operation) return 'Operation';
  return operation.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
}
function parseJustification(markdown) {
  if (!markdown || typeof markdown !== 'string') return [];
  const hasNewlines = /\r?\n/.test(markdown.trim());
  const lines = hasNewlines ? markdown.split(/\r?\n/) : markdown.split(/(?:^|\s)- /).filter(Boolean);
  return lines.map(line => line.replace(/^- +/, '').trim()).filter(Boolean);
}
function splitBullets(text) {
  if (!text || typeof text !== 'string') return [];
  if (text.includes('•')) return text.split('•').map(item => item.trim()).filter(Boolean);
  return text.split(/\r?\n/).map(item => item.replace(/^- +/, '').trim()).filter(Boolean);
}
function formatTicketRefsMarkdown(refs) {
  if (!refs) return '';
  const entries = Object.entries(refs).filter(_ref => {
    let [, value] = _ref;
    return value != null && value !== '';
  });
  if (entries.length === 0) return '';
  const lines = entries.map(_ref2 => {
    let [key, value] = _ref2;
    const match = key.match(/^ref(\d+)_(.+)$/);
    const label = match ? "Reference ".concat(match[1], " (").concat(TICKET_REF_LABELS[key] || match[2].replace(/_/g, ' '), ")") : key;
    return "- **".concat(label, ":** `").concat(value, "`");
  });
  return "\n\n**ServiceNow References:**\n".concat(lines.join('\n'));
}
function openOverrideWindow(path, storageKey, payload, queryKey, goldenId) {
  localStorage.setItem(storageKey, JSON.stringify(payload));
  const params = new URLSearchParams({
    goldenId: goldenId || '',
    [queryKey]: storageKey
  });
  window.open("".concat(path, "?").concat(params.toString()), '_blank', 'noopener,noreferrer');
}
function Pill(_ref3) {
  let {
    tone = 'slate',
    children
  } = _ref3;
  const tones = {
    slate: {
      bg: '#f1f5f9',
      color: '#475569',
      border: '#cbd5e1'
    },
    blue: {
      bg: '#dbeafe',
      color: '#1e40af',
      border: '#60a5fa'
    },
    green: {
      bg: '#d1fae5',
      color: '#065f46',
      border: '#34d399'
    },
    amber: {
      bg: '#fff7ed',
      color: '#dd6b20',
      border: '#dd6b20'
    },
    red: {
      bg: '#fee2e2',
      color: '#991b1b',
      border: '#f87171'
    },
    indigo: {
      bg: '#e0e7ff',
      color: '#3730a3',
      border: '#818cf8'
    }
  };
  const t = tones[tone] || tones.slate;
  return (0, _jsxRuntime.jsx)("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      borderRadius: '9999px',
      border: "1.5px solid ".concat(t.border),
      padding: '3px 10px',
      fontSize: '11px',
      fontWeight: 700,
      letterSpacing: '0.02em',
      background: t.bg,
      color: t.color,
      whiteSpace: 'nowrap',
      boxShadow: "0 1px 4px ".concat(t.border, "44")
    },
    children: children
  });
}
function SectionCard(_ref4) {
  let {
    eyebrow,
    title,
    description,
    children,
    accent = 'tw-from-white tw-to-slate-50'
  } = _ref4;
  return (0, _jsxRuntime.jsxs)("section", {
    className: "tw-rounded-[18px] tw-border tw-border-slate-200 tw-bg-gradient-to-br ".concat(accent, " tw-p-4 tw-shadow-[0_10px_24px_rgba(15,23,42,0.06)] tw-overflow-hidden tw-min-w-0"),
    children: [(eyebrow || title || description) && (0, _jsxRuntime.jsxs)("div", {
      className: "tw-mb-3",
      children: [eyebrow && (0, _jsxRuntime.jsx)("div", {
        className: "tw-mb-1 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.18em] tw-text-slate-500",
        children: eyebrow
      }), title && (0, _jsxRuntime.jsx)("div", {
        className: "tw-text-[15px] tw-font-semibold tw-text-slate-900",
        children: title
      }), description && (0, _jsxRuntime.jsx)("div", {
        className: "tw-mt-1 tw-text-[12px] tw-leading-5 tw-text-slate-600",
        children: description
      })]
    }), children]
  });
}
function SummaryList(_ref5) {
  let {
    items,
    emptyText
  } = _ref5;
  if (!items.length) return (0, _jsxRuntime.jsx)("div", {
    className: "tw-text-[12px] tw-text-slate-500",
    children: emptyText
  });
  return (0, _jsxRuntime.jsx)("ul", {
    className: "tw-m-0 tw-grid tw-gap-2 tw-pl-4 tw-text-[12px] tw-leading-5 tw-text-slate-700",
    children: items.map((item, index) => (0, _jsxRuntime.jsx)("li", {
      children: item
    }, "".concat(item, "-").concat(index)))
  });
}
function DecisionBanner(_ref6) {
  let {
    status,
    operationLabel,
    message
  } = _ref6;
  const tones = {
    approved: {
      border: '#16a34a',
      bg: '#dcfce7',
      iconBg: '#16a34a',
      title: "".concat(operationLabel, " approved"),
      symbol: '✓'
    },
    rejected: {
      border: '#dc2626',
      bg: '#fee2e2',
      iconBg: '#dc2626',
      title: "".concat(operationLabel, " rejected"),
      symbol: '✕'
    },
    error: {
      border: '#F0B67E',
      bg: '#FCF0E5',
      iconBg: '#BF9055',
      title: 'Action failed',
      symbol: '!'
    },
    pending: {
      border: '#C0D0E6',
      bg: '#EAEFF5',
      iconBg: '#002677',
      title: 'Submitting decision',
      symbol: '…'
    }
  };
  const tone = tones[status];
  if (!tone) return null;
  return (0, _jsxRuntime.jsxs)("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '12px',
      borderRadius: '12px',
      border: "1px solid ".concat(tone.border),
      background: tone.bg,
      padding: '14px'
    },
    children: [(0, _jsxRuntime.jsx)("div", {
      style: {
        display: 'flex',
        width: '32px',
        height: '32px',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        background: tone.iconBg,
        color: '#ffffff',
        fontSize: '14px',
        fontWeight: 700
      },
      children: tone.symbol
    }), (0, _jsxRuntime.jsxs)("div", {
      children: [(0, _jsxRuntime.jsx)("div", {
        style: {
          fontSize: '13px',
          fontWeight: 600,
          color: '#1e293b'
        },
        children: tone.title
      }), message && (0, _jsxRuntime.jsx)("div", {
        style: {
          marginTop: '4px',
          fontSize: '12px',
          lineHeight: '1.5',
          color: '#334155'
        },
        children: message
      })]
    })]
  });
}
function RawFallback(_ref7) {
  let {
    data
  } = _ref7;
  return (0, _jsxRuntime.jsxs)("div", {
    className: "tw-mt-2 tw-overflow-hidden tw-rounded-[18px] tw-border tw-border-slate-200 tw-bg-slate-950",
    children: [(0, _jsxRuntime.jsx)("div", {
      className: "tw-border-b tw-border-slate-800 tw-px-4 tw-py-2 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.18em] tw-text-slate-400",
      children: "Raw response"
    }), (0, _jsxRuntime.jsx)("pre", {
      className: "tw-m-0 tw-max-h-[320px] tw-overflow-auto tw-whitespace-pre-wrap tw-break-words tw-p-4 tw-text-[11px] tw-leading-5 tw-text-slate-100",
      children: JSON.stringify((data === null || data === void 0 ? void 0 : data.message) || data, null, 2)
    })]
  });
}
function InsightsView(_ref8) {
  let {
    summary,
    goldenId,
    mode = 'sidebar'
  } = _ref8;
  const overmerge = summary === null || summary === void 0 ? void 0 : summary.overmerge_analysis;
  const insights = splitBullets(summary === null || summary === void 0 ? void 0 : summary.insights);
  const dataQuality = splitBullets(summary === null || summary === void 0 ? void 0 : summary.dataQuality);
  const statusTone = overmerge !== null && overmerge !== void 0 && overmerge.is_overmerge ? 'red' : 'green';
  const [showReasoning, setShowReasoning] = (0, _react.useState)(false);
  const [showDataQuality, setShowDataQuality] = (0, _react.useState)(false);
  const confValue = overmerge === null || overmerge === void 0 ? void 0 : overmerge.confidence;
  const confTone = typeof confValue === 'number' ? confValue > 0.7 ? 'green' : confValue >= 0.3 ? 'amber' : 'red' : 'slate';
  const confLabel = typeof confValue === 'number' ? "".concat(Math.round(confValue * 100), "%") : confValue;
  return (0, _jsxRuntime.jsx)("div", {
    className: "tw-mt-2 tw-grid tw-gap-3",
    children: (0, _jsxRuntime.jsxs)(SectionCard, {
      title: "EID Insights",
      accent: "tw-from-white tw-via-slate-50 tw-to-[#EAEFF5]",
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "tw-flex tw-flex-wrap tw-items-center tw-gap-2",
        children: [goldenId && (0, _jsxRuntime.jsxs)(Pill, {
          tone: "blue",
          children: ["EID: ", String(goldenId)]
        }), (0, _jsxRuntime.jsx)(Pill, {
          tone: statusTone,
          children: overmerge !== null && overmerge !== void 0 && overmerge.is_overmerge ? 'Overmerge Detected' : 'No Overmerge'
        }), confLabel && mode === 'standalone' && (0, _jsxRuntime.jsxs)(Pill, {
          tone: confTone,
          children: ["Confidence: ", confLabel]
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        className: "tw-mt-3",
        children: (0, _jsxRuntime.jsx)(SummaryList, {
          items: insights,
          emptyText: "No summary points were returned."
        })
      }), (0, _jsxRuntime.jsxs)("div", {
        className: "tw-mt-3 tw-flex tw-flex-wrap tw-gap-2",
        children: [(overmerge === null || overmerge === void 0 ? void 0 : overmerge.analysis) && (0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "tw-cursor-pointer tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-[12px] tw-font-semibold tw-transition-colors ".concat(showReasoning ? 'tw-border-[#2563eb] tw-bg-[#F0F8FA] tw-text-[#2563eb]' : 'tw-border-slate-200 tw-bg-white tw-text-slate-600 hover:tw-border-slate-300 hover:tw-bg-slate-50'),
          onClick: () => setShowReasoning(v => !v),
          children: [showReasoning ? '▼' : '▶', " Overmerge Analysis"]
        }), dataQuality.length > 0 && (0, _jsxRuntime.jsxs)("button", {
          type: "button",
          className: "tw-cursor-pointer tw-rounded-full tw-border tw-px-3 tw-py-1.5 tw-text-[12px] tw-font-semibold tw-transition-colors ".concat(showDataQuality ? 'tw-border-[#2563eb] tw-bg-[#F0F8FA] tw-text-[#2563eb]' : 'tw-border-slate-200 tw-bg-white tw-text-slate-600 hover:tw-border-slate-300 hover:tw-bg-slate-50'),
          onClick: () => setShowDataQuality(v => !v),
          children: [showDataQuality ? '▼' : '▶', " Data Quality"]
        })]
      }), showReasoning && (overmerge === null || overmerge === void 0 ? void 0 : overmerge.analysis) && (0, _jsxRuntime.jsxs)("div", {
        className: "tw-mt-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-3",
        children: [(0, _jsxRuntime.jsx)("div", {
          className: "tw-text-[12px] tw-leading-6 tw-text-slate-700",
          children: overmerge.analysis
        }), Array.isArray(overmerge.supporting_evidence) && overmerge.supporting_evidence.length > 0 && (0, _jsxRuntime.jsxs)("div", {
          className: "tw-mt-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-3",
          children: [(0, _jsxRuntime.jsx)("div", {
            className: "tw-mb-2 tw-text-[12px] tw-font-semibold tw-text-slate-900",
            children: "Supporting evidence"
          }), (0, _jsxRuntime.jsx)(SummaryList, {
            items: overmerge.supporting_evidence,
            emptyText: "No evidence provided."
          })]
        })]
      }), showDataQuality && dataQuality.length > 0 && (0, _jsxRuntime.jsx)("div", {
        className: "tw-mt-3 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-3",
        children: (0, _jsxRuntime.jsx)(SummaryList, {
          items: dataQuality,
          emptyText: "No data quality issues were returned."
        })
      })]
    })
  });
}
function PlanView(_ref9) {
  var _data$message, _plan$proposed_operat, _plan$proposed_operat2, _plan$proposed_operat3, _plan$proposed_operat4, _overrideRequest$pati, _plan$execution_reaso, _plan$execution_reaso2;
  let {
    data,
    plan,
    goldenId: goldenIdProp,
    onAddMessages,
    isSidebar = false,
    messageId,
    mode = 'sidebar'
  } = _ref9;
  const {
    updatePageContext,
    activeThread,
    sidebarWidth,
    setSidebarWidth
  } = (0, _AssistantProvider.useAssistant)();
  const goldenId = goldenIdProp || (plan === null || plan === void 0 ? void 0 : plan.eid) || (data === null || data === void 0 || (_data$message = data.message) === null || _data$message === void 0 || (_data$message = _data$message.result) === null || _data$message === void 0 ? void 0 : _data$message.eid) || '';
  const threadId = data === null || data === void 0 ? void 0 : data.thread_id;
  const metadata = data === null || data === void 0 ? void 0 : data.metadata;
  const interrupted = data === null || data === void 0 ? void 0 : data.interrupted;
  const priorDecision = _react.default.useMemo(() => {
    if (!messageId || !(activeThread !== null && activeThread !== void 0 && activeThread.messages)) return null;
    const msgs = activeThread.messages;
    const idx = msgs.findIndex(m => m.id === messageId);
    if (idx < 0) return null;
    for (let i = idx + 1; i < msgs.length; i++) {
      const m = msgs[i];
      if (m.role === 'user' && m.text === '✓ Approved') return 'approved';
      if (m.role === 'user' && m.text === '✕ Rejected') return 'rejected';
    }
    return null;
  }, [messageId, activeThread]);
  const [summaryViewed, setSummaryViewed] = (0, _react.useState)(!!priorDecision);
  const [previewViewed, setPreviewViewed] = (0, _react.useState)(!!priorDecision);
  const [actionStatus, setActionStatus] = (0, _react.useState)(priorDecision);
  const [actionMessage, setActionMessage] = (0, _react.useState)('');
  const operation = plan === null || plan === void 0 || (_plan$proposed_operat = plan.proposed_operation) === null || _plan$proposed_operat === void 0 ? void 0 : _plan$proposed_operat.tool_name;
  const operationLabel = formatOperationLabel(operation);
  const targets = (plan === null || plan === void 0 || (_plan$proposed_operat2 = plan.proposed_operation) === null || _plan$proposed_operat2 === void 0 ? void 0 : _plan$proposed_operat2.targets) || [];
  const justificationBullets = parseJustification((plan === null || plan === void 0 || (_plan$proposed_operat3 = plan.proposed_operation) === null || _plan$proposed_operat3 === void 0 ? void 0 : _plan$proposed_operat3.justification) || '');
  const overrideRequest = (plan === null || plan === void 0 || (_plan$proposed_operat4 = plan.proposed_operation) === null || _plan$proposed_operat4 === void 0 ? void 0 : _plan$proposed_operat4.override_request) || (plan === null || plan === void 0 ? void 0 : plan.override_request);
  const overrideCount = (overrideRequest === null || overrideRequest === void 0 || (_overrideRequest$pati = overrideRequest.patients) === null || _overrideRequest$pati === void 0 ? void 0 : _overrideRequest$pati.length) || 0;
  const canDecide = interrupted && (previewViewed || overrideCount === 0);
  const isStandalone = mode === 'standalone';
  const isSmartAssistPage = isStandalone && window.location.pathname.includes('/smartassist');
  const isFullScreenSidebar = mode === 'sidebar' && sidebarWidth >= window.innerWidth * 0.95;
  const rawConf = plan !== null && plan !== void 0 && (_plan$execution_reaso = plan.execution_reasoning) !== null && _plan$execution_reaso !== void 0 && _plan$execution_reaso.plan_guidance_used ? plan === null || plan === void 0 || (_plan$execution_reaso2 = plan.execution_reasoning) === null || _plan$execution_reaso2 === void 0 ? void 0 : _plan$execution_reaso2.guidance_confidence : plan === null || plan === void 0 ? void 0 : plan.confidence;
  const confTone = typeof rawConf === 'number' ? rawConf > 0.7 ? 'green' : rawConf >= 0.3 ? 'amber' : 'red' : 'slate';
  const confLabel = typeof rawConf === 'number' ? "".concat(Math.round(rawConf * 100), "%") : typeof rawConf === 'string' ? rawConf.toUpperCase() : null;
  const activatePreview = () => {
    if (isStandalone) {
      const previewKey = "override_preview_".concat(Date.now());
      try {
        localStorage.setItem(previewKey, JSON.stringify(overrideRequest));
      } catch (_unused) {}
      const params = new URLSearchParams({
        goldenId: goldenId || '',
        previewKey
      });
      window.open("/override-preview?".concat(params.toString()), '_blank', 'noopener,noreferrer');
      setPreviewViewed(true);
      return;
    }
    if (isFullScreenSidebar) {
      setSidebarWidth(_constants.SIDEBAR.DEFAULT_WIDTH);
    }
    updatePageContext({
      previewMode: true,
      overrideRequest: overrideRequest,
      previewGoldenId: goldenId
    });
    setPreviewViewed(true);
  };
  const exitPreview = () => {
    updatePageContext({
      previewMode: false,
      overrideRequest: null,
      previewGoldenId: null
    });
  };
  const runDecision = async decisionType => {
    const isApproval = decisionType === 'accept';
    setActionStatus('pending');
    try {
      var _responseData$message, _responseData$message2, _responseData$message3;
      let response;
      if (isMockEnabled()) {
        response = await fetch('/chatSyncActionMock.json');
      } else {
        const xPromptVersion = process.env.REACT_APP_X_PROMPT_VERSION;
        response = await fetch("".concat(getApiUrl(), "/v1/ai/chat/sync"), {
          method: 'POST',
          headers: _objectSpread(_objectSpread({}, getDecisionHeaders()), {}, {
            'Content-Type': 'application/json',
            'x-prompt-version': xPromptVersion
          }),
          body: JSON.stringify({
            body: {
              message: {
                type: decisionType
              },
              thread_id: threadId
            }
          })
        });
      }
      if (!response.ok) {
        if (response.status === 403) {
          let errorMessage = 'You do not have permission to approve or reject requests. Please contact your administrator for access.';
          try {
            const errorData = await response.json();
            if (errorData.detail) errorMessage = errorData.detail;
          } catch (e) {}
          setActionStatus('error');
          setActionMessage(errorMessage);
          if (onAddMessages) {
            setTimeout(() => onAddMessages([{
              role: 'user',
              text: isApproval ? '✓ Approved' : '✕ Rejected'
            }, {
              role: 'assistant',
              text: "\uD83D\uDEAB **Access Denied**\n\n".concat(errorMessage),
              isAiGenerated: false
            }]), 0);
          }
          return;
        }
        throw new Error("HTTP ".concat(response.status, ": ").concat(response.statusText));
      }
      const responseData = await response.json();
      const executionFailed = (_responseData$message = responseData.message) === null || _responseData$message === void 0 ? void 0 : _responseData$message.execution_failed;
      const rawText = (_responseData$message2 = responseData.message) === null || _responseData$message2 === void 0 ? void 0 : _responseData$message2.raw_text;
      if (executionFailed) {
        const errorMessage = rawText || "".concat(operationLabel, " execution failed. Please try again.");
        setActionStatus('error');
        setActionMessage(errorMessage);
        if (onAddMessages) {
          setTimeout(() => onAddMessages([{
            role: 'user',
            text: isApproval ? '✓ Approved' : '✕ Rejected'
          }, {
            role: 'assistant',
            text: "\u274C **".concat(operationLabel, " Failed**\n\n").concat(errorMessage),
            isAiGenerated: false
          }]), 0);
        }
        return;
      }
      if ((_responseData$message3 = responseData.message) !== null && _responseData$message3 !== void 0 && _responseData$message3.result) {
        setActionStatus(isApproval ? 'approved' : 'rejected');
        setActionMessage("".concat(operationLabel, " ").concat(isApproval ? 'approved' : 'rejected', ". A new recommendation was returned."));
        exitPreview();
        if (isApproval && !isSmartAssistPage) {
          try {
            sessionStorage.setItem('sa_sidebar_reopen', 'true');
            localStorage.setItem('sa_sidebar_width', String(_constants.SIDEBAR.DEFAULT_WIDTH));
          } catch (_unused2) {}
          setTimeout(() => window.location.reload(), 1500);
        }
        if (onAddMessages) {
          setTimeout(() => onAddMessages([{
            role: 'user',
            text: isApproval ? '✓ Approved' : '✕ Rejected'
          }, {
            role: 'assistant',
            json: responseData,
            isAiGenerated: true
          }]), 0);
        }
        return;
      }
      const refsMarkdown = responseData.ticket_references ? formatTicketRefsMarkdown(responseData.ticket_references) : '';
      let message;
      if (isApproval) {
        if (operation === 'recompute') {
          message = "".concat(operationLabel, " has been initiated. The member EID will be refreshed. Please search for the identity to verify the changes.");
        } else {
          message = "".concat(operationLabel, " has been approved and applied successfully.").concat(targets.length > 0 ? ' Please search for the identity using the targeted record IDs to verify the changes.' : '');
        }
      } else if (operation === 'recompute') {
        message = "".concat(operationLabel, " has been rejected. The member EID remains unchanged.");
      } else {
        message = "".concat(operationLabel, " has been rejected. No changes were made - the records remain as they are.");
      }
      setActionStatus(isApproval ? 'approved' : 'rejected');
      setActionMessage(message);
      exitPreview();
      if (isApproval && !isSmartAssistPage) {
        try {
          sessionStorage.setItem('sa_sidebar_reopen', 'true');
          localStorage.setItem('sa_sidebar_width', String(_constants.SIDEBAR.DEFAULT_WIDTH));
        } catch (_unused3) {}
        setTimeout(() => window.location.reload(), 1500);
      }
      if (onAddMessages) {
        setTimeout(() => onAddMessages([{
          role: 'user',
          text: isApproval ? '✓ Approved' : '✕ Rejected'
        }, {
          role: 'assistant',
          text: "".concat(isApproval ? '✅' : '🚫', " **").concat(operationLabel, " ").concat(isApproval ? 'Approved' : 'Rejected', "**\n\n").concat(message).concat(refsMarkdown),
          isAiGenerated: true
        }]), 0);
      }
    } catch (error) {
      const errorMessage = "Failed to ".concat(isApproval ? 'approve' : 'reject', " ").concat(operationLabel.toLowerCase(), ": ").concat(error.message, ". Please try again.");
      setActionStatus('error');
      setActionMessage(errorMessage);
      if (onAddMessages) {
        setTimeout(() => onAddMessages([{
          role: 'user',
          text: isApproval ? '✓ Approved' : '✕ Rejected'
        }, {
          role: 'assistant',
          text: "\u274C **".concat(isApproval ? operationLabel : 'Rejection', " Failed**\n\n").concat(errorMessage),
          isAiGenerated: true
        }]), 0);
      }
    }
  };
  const opColor = operation === 'record_override' ? '#4f46e5' : operation === 'recompute' ? '#059669' : '#d97706';
  return (0, _jsxRuntime.jsx)("div", {
    style: {
      marginTop: '8px'
    },
    children: (0, _jsxRuntime.jsxs)("div", {
      style: {
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f0f8fa 100%)',
        boxShadow: '0 4px 16px rgba(15, 23, 42, 0.06)',
        overflow: 'hidden'
      },
      children: [(0, _jsxRuntime.jsxs)("div", {
        style: {
          padding: '14px 16px',
          borderBottom: '1px solid #e2e8f0',
          background: 'linear-gradient(90deg, #f8fafc 0%, #eef2ff 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          flexWrap: 'wrap'
        },
        children: [(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          },
          children: [(0, _jsxRuntime.jsx)("span", {
            style: {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px',
              borderRadius: '10px',
              background: 'transparent',
              border: "2px solid ".concat(opColor),
              color: opColor,
              fontSize: '14px'
            },
            children: operation === 'record_override' ? (0, _jsxRuntime.jsxs)("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [(0, _jsxRuntime.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              }), (0, _jsxRuntime.jsx)("polyline", {
                points: "14 2 14 8 20 8"
              }), (0, _jsxRuntime.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "8",
                y2: "13"
              }), (0, _jsxRuntime.jsx)("line", {
                x1: "16",
                y1: "17",
                x2: "8",
                y2: "17"
              }), (0, _jsxRuntime.jsx)("polyline", {
                points: "10 9 9 9 8 9"
              })]
            }) : operation === 'recompute' ? (0, _jsxRuntime.jsxs)("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [(0, _jsxRuntime.jsx)("polyline", {
                points: "23 4 23 10 17 10"
              }), (0, _jsxRuntime.jsx)("polyline", {
                points: "1 20 1 14 7 14"
              }), (0, _jsxRuntime.jsx)("path", {
                d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10"
              }), (0, _jsxRuntime.jsx)("path", {
                d: "M20.49 15a9 9 0 0 1-14.85 3.36L1 14"
              })]
            }) : (0, _jsxRuntime.jsxs)("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [(0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              }), (0, _jsxRuntime.jsx)("path", {
                d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
              })]
            })
          }), (0, _jsxRuntime.jsxs)("div", {
            children: [(0, _jsxRuntime.jsx)("div", {
              style: {
                fontSize: '14px',
                fontWeight: 700,
                color: '#1e293b'
              },
              children: operationLabel
            }), !isSidebar && (plan === null || plan === void 0 ? void 0 : plan.eid) && (0, _jsxRuntime.jsxs)("div", {
              style: {
                fontSize: '11px',
                color: '#64748b',
                marginTop: '2px'
              },
              children: ["EID: ", String(plan.eid)]
            })]
          })]
        }), (0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            flexWrap: 'wrap'
          },
          children: [interrupted && !actionStatus && (0, _jsxRuntime.jsx)("span", {
            style: {
              display: 'inline-flex',
              alignItems: 'center',
              borderRadius: '9999px',
              padding: '4px 12px',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '0.02em',
              background: '#d97706',
              color: '#ffffff',
              whiteSpace: 'nowrap',
              boxShadow: '0 1px 4px rgba(217, 119, 6, 0.3)'
            },
            children: "Awaiting Approval"
          }), actionStatus === 'approved' && (0, _jsxRuntime.jsx)(Pill, {
            tone: "green",
            children: "\u2705 Approved"
          }), actionStatus === 'rejected' && (0, _jsxRuntime.jsx)(Pill, {
            tone: "red",
            children: "\uD83D\uDEAB Rejected"
          }), actionStatus === 'error' && (0, _jsxRuntime.jsx)(Pill, {
            tone: "red",
            children: "\u274C Error"
          }), confLabel && !actionStatus && isStandalone && (0, _jsxRuntime.jsxs)(Pill, {
            tone: confTone,
            children: ["Confidence: ", confLabel]
          })]
        })]
      }), (0, _jsxRuntime.jsxs)("div", {
        style: {
          padding: '16px',
          display: 'grid',
          gap: '14px'
        },
        children: [(0, _jsxRuntime.jsxs)("div", {
          style: {
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            background: '#ffffff',
            padding: '12px'
          },
          children: [(0, _jsxRuntime.jsx)("div", {
            style: {
              marginBottom: '8px',
              fontSize: '12px',
              fontWeight: 600,
              color: '#1e293b'
            },
            children: "Analysis and recommendation"
          }), (0, _jsxRuntime.jsx)(SummaryList, {
            items: justificationBullets,
            emptyText: "No recommendation summary was returned."
          })]
        }), overrideCount > 0 && !previewViewed && !summaryViewed && (0, _jsxRuntime.jsx)("div", {
          style: {
            borderRadius: '12px',
            border: '2px dashed #C0D0E6',
            background: '#F0F8FA',
            padding: '16px'
          },
          children: (0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              gap: '12px'
            },
            children: [(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                width: '40px',
                height: '40px',
                flexShrink: 0,
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                background: '#EAEFF5',
                fontSize: '18px'
              },
              children: "\uD83D\uDC41\uFE0F"
            }), (0, _jsxRuntime.jsxs)("div", {
              children: [(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '13px',
                  fontWeight: 800,
                  color: '#1e293b'
                },
                children: "Wait, check the changes first!"
              }), (0, _jsxRuntime.jsxs)("div", {
                style: {
                  marginTop: '4px',
                  fontSize: '12px',
                  lineHeight: '1.5',
                  color: '#475569'
                },
                children: ["Before making any changes, take a quick look at the ", (0, _jsxRuntime.jsx)("strong", {
                  children: "Override Preview & Summary"
                }), ". It shows you the before\u2011and\u2011after view of the records, along with the Focus Identity."]
              }), (0, _jsxRuntime.jsxs)("div", {
                style: {
                  marginTop: '12px',
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px'
                },
                children: [(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  style: {
                    cursor: 'pointer',
                    borderRadius: '9999px',
                    border: '1px solid #2563eb',
                    background: '#2563eb',
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: '#ffffff'
                  },
                  onMouseEnter: e => {
                    e.target.style.background = '#1d4ed8';
                    e.target.style.borderColor = '#1d4ed8';
                  },
                  onMouseLeave: e => {
                    e.target.style.background = '#2563eb';
                    e.target.style.borderColor = '#2563eb';
                  },
                  onClick: () => {
                    const key = "override_summary_".concat(Date.now());
                    openOverrideWindow('/override-summary', key, overrideRequest, 'summaryKey', goldenId);
                    setSummaryViewed(true);
                  },
                  children: "View Summary \u2192"
                }), (0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  style: {
                    cursor: 'pointer',
                    borderRadius: '9999px',
                    border: '1px solid #2563eb',
                    background: '#2563eb',
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: 600,
                    color: '#ffffff'
                  },
                  onMouseEnter: e => {
                    e.target.style.background = '#1d4ed8';
                    e.target.style.borderColor = '#1d4ed8';
                  },
                  onMouseLeave: e => {
                    e.target.style.background = '#2563eb';
                    e.target.style.borderColor = '#2563eb';
                  },
                  onClick: () => {
                    activatePreview();
                  },
                  children: "Golden Record Impact Preview \u2192"
                })]
              })]
            })]
          })
        }), overrideCount > 0 && summaryViewed && !previewViewed && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: '12px',
              border: '2px dotted #C0D0E6',
              background: '#ffffff',
              padding: '8px 12px'
            },
            children: [(0, _jsxRuntime.jsxs)("span", {
              style: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '12px',
                color: '#334155'
              },
              children: [(0, _jsxRuntime.jsx)("span", {
                style: {
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  background: '#38A169',
                  fontSize: '10px',
                  color: '#ffffff'
                },
                children: "\u2713"
              }), "Summary viewed"]
            }), (0, _jsxRuntime.jsx)("button", {
              type: "button",
              style: {
                cursor: 'pointer',
                border: 'none',
                background: 'transparent',
                fontSize: '12px',
                fontWeight: 600,
                color: '#2563eb',
                padding: 0
              },
              onClick: () => {
                const key = "override_summary_".concat(Date.now());
                openOverrideWindow('/override-summary', key, overrideRequest, 'summaryKey', goldenId);
              },
              children: "Re-open summary"
            })]
          }), (0, _jsxRuntime.jsx)("div", {
            style: {
              borderRadius: '12px',
              border: '2px dashed #C0D0E6',
              background: '#F0F8FA',
              padding: '16px'
            },
            children: (0, _jsxRuntime.jsxs)("div", {
              style: {
                display: 'flex',
                gap: '12px'
              },
              children: [(0, _jsxRuntime.jsx)("div", {
                style: {
                  display: 'flex',
                  width: '40px',
                  height: '40px',
                  flexShrink: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  background: '#EAEFF5',
                  fontSize: '18px'
                },
                children: "\uD83D\uDC41\uFE0F"
              }), (0, _jsxRuntime.jsxs)("div", {
                children: [(0, _jsxRuntime.jsx)("div", {
                  style: {
                    fontSize: '13px',
                    fontWeight: 800,
                    color: '#1e293b'
                  },
                  children: "Great! Now check the golden record impact preview"
                }), (0, _jsxRuntime.jsxs)("div", {
                  style: {
                    marginTop: '4px',
                    fontSize: '12px',
                    lineHeight: '1.5',
                    color: '#475569'
                  },
                  children: ["You've seen the summary. To proceed with approval, please review the ", (0, _jsxRuntime.jsx)("strong", {
                    children: "Golden Record Impact Preview"
                  }), "."]
                }), (0, _jsxRuntime.jsx)("div", {
                  style: {
                    marginTop: '12px'
                  },
                  children: (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    style: {
                      cursor: 'pointer',
                      borderRadius: '9999px',
                      border: '1px solid #2563eb',
                      background: '#2563eb',
                      padding: '6px 12px',
                      fontSize: '12px',
                      fontWeight: 600,
                      color: '#ffffff'
                    },
                    onMouseEnter: e => {
                      e.target.style.background = '#1d4ed8';
                      e.target.style.borderColor = '#1d4ed8';
                    },
                    onMouseLeave: e => {
                      e.target.style.background = '#2563eb';
                      e.target.style.borderColor = '#2563eb';
                    },
                    onClick: () => {
                      activatePreview();
                    },
                    children: "Golden Record Impact Preview \u2192"
                  })
                })]
              })]
            })
          })]
        }), overrideCount > 0 && previewViewed && (0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '12px',
            border: '2px dotted #C0D0E6',
            background: '#ffffff',
            padding: '8px 12px'
          },
          children: [(0, _jsxRuntime.jsxs)("span", {
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px',
              color: '#334155'
            },
            children: [(0, _jsxRuntime.jsx)("span", {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                background: '#38A169',
                fontSize: '10px',
                color: '#ffffff'
              },
              children: "\u2713"
            }), "Preview viewed"]
          }), (0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              gap: '12px'
            },
            children: [(0, _jsxRuntime.jsx)("button", {
              type: "button",
              style: {
                cursor: 'pointer',
                border: 'none',
                background: 'transparent',
                fontSize: '12px',
                fontWeight: 600,
                color: '#2563eb',
                padding: 0
              },
              onClick: () => {
                activatePreview();
              },
              children: "Re-open preview"
            }), (0, _jsxRuntime.jsx)("button", {
              type: "button",
              style: {
                cursor: 'pointer',
                border: 'none',
                background: 'transparent',
                fontSize: '12px',
                fontWeight: 600,
                color: '#2563eb',
                padding: 0
              },
              onClick: () => {
                const key = "override_summary_".concat(Date.now());
                openOverrideWindow('/override-summary', key, overrideRequest, 'summaryKey', goldenId);
              },
              children: "Re-open summary"
            })]
          })]
        }), (0, _jsxRuntime.jsx)(DecisionBanner, {
          status: actionStatus,
          operationLabel: operationLabel,
          message: actionMessage
        }), !actionStatus && canDecide && (0, _jsxRuntime.jsxs)("div", {
          style: {
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            background: '#ffffff',
            padding: '14px'
          },
          children: [(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '12px',
              fontWeight: 600,
              color: '#1e293b',
              marginBottom: '10px'
            },
            children: "\u2696\uFE0F Should I go ahead and apply the changes?"
          }), (0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              gap: '10px'
            },
            children: [(0, _jsxRuntime.jsx)("button", {
              type: "button",
              style: {
                cursor: 'pointer',
                borderRadius: '9999px',
                border: 'none',
                background: '#16a34a',
                padding: '8px 20px',
                fontSize: '13px',
                fontWeight: 700,
                color: '#ffffff',
                boxShadow: '0 2px 8px rgba(22, 163, 74, 0.35)'
              },
              onMouseEnter: e => e.target.style.background = '#15803d',
              onMouseLeave: e => e.target.style.background = '#16a34a',
              onClick: () => runDecision('accept'),
              title: "Approve this recommendation",
              children: "\u2713 Approve"
            }), (0, _jsxRuntime.jsx)("button", {
              type: "button",
              style: {
                cursor: 'pointer',
                borderRadius: '9999px',
                border: 'none',
                background: '#dc2626',
                padding: '8px 20px',
                fontSize: '13px',
                fontWeight: 700,
                color: '#ffffff',
                boxShadow: '0 2px 8px rgba(220, 38, 38, 0.35)'
              },
              onMouseEnter: e => e.target.style.background = '#b91c1c',
              onMouseLeave: e => e.target.style.background = '#dc2626',
              onClick: () => runDecision('reject'),
              title: "Reject this recommendation",
              children: "\u2715 Reject"
            })]
          }), (0, _jsxRuntime.jsxs)("div", {
            style: {
              marginTop: '8px',
              fontSize: '11px',
              lineHeight: 1.4,
              color: '#94a3b8'
            },
            children: [(0, _jsxRuntime.jsx)("strong", {
              children: "Approve"
            }), " applies the changes right away. ", (0, _jsxRuntime.jsx)("strong", {
              children: "Reject"
            }), " leaves the records as they are."]
          })]
        })]
      })]
    })
  });
}
function ModernStructuredMessage(_ref0) {
  var _data$message2, _data$message3, _data$message4, _data$message5, _data$message6, _data$message7, _data$message8;
  let {
    data,
    goldenID,
    onAddMessages,
    isSidebar = false,
    messageId,
    mode = 'sidebar'
  } = _ref0;
  const error = data === null || data === void 0 ? void 0 : data.error;
  const plan = (data === null || data === void 0 || (_data$message2 = data.message) === null || _data$message2 === void 0 || (_data$message2 = _data$message2.data_correction) === null || _data$message2 === void 0 ? void 0 : _data$message2.result) || (data === null || data === void 0 || (_data$message3 = data.message) === null || _data$message3 === void 0 ? void 0 : _data$message3.result);
  const summary = (data === null || data === void 0 || (_data$message4 = data.message) === null || _data$message4 === void 0 || (_data$message4 = _data$message4.entity_summary) === null || _data$message4 === void 0 ? void 0 : _data$message4.result) || (data === null || data === void 0 || (_data$message5 = data.message) === null || _data$message5 === void 0 ? void 0 : _data$message5.result);
  const rawText = (data === null || data === void 0 || (_data$message6 = data.message) === null || _data$message6 === void 0 ? void 0 : _data$message6.raw_text) || (data === null || data === void 0 || (_data$message7 = data.message) === null || _data$message7 === void 0 || (_data$message7 = _data$message7.entity_summary) === null || _data$message7 === void 0 ? void 0 : _data$message7.raw_text) || (data === null || data === void 0 || (_data$message8 = data.message) === null || _data$message8 === void 0 || (_data$message8 = _data$message8.data_correction) === null || _data$message8 === void 0 ? void 0 : _data$message8.raw_text);
  if (error) {
    return (0, _jsxRuntime.jsx)(SectionCard, {
      eyebrow: "Assistant error",
      title: "The assistant could not process this request",
      description: "The backend returned an error state for this message. Try rerunning the action or narrowing the prompt.",
      accent: "tw-from-white tw-to-[#F7D8D9]",
      children: (0, _jsxRuntime.jsx)("div", {
        className: "tw-text-[12px] tw-leading-5 tw-text-slate-700",
        children: typeof error === 'string' ? error : 'Please try again later.'
      })
    });
  }
  if (summary && (summary.overmerge_analysis || summary.insights || summary.dataQuality)) {
    return (0, _jsxRuntime.jsx)(InsightsView, {
      summary: summary,
      goldenId: goldenID,
      mode: mode
    });
  }
  if (plan !== null && plan !== void 0 && plan.proposed_operation) {
    return (0, _jsxRuntime.jsx)(PlanView, {
      data: data,
      plan: plan,
      goldenId: goldenID,
      onAddMessages: onAddMessages,
      isSidebar: isSidebar,
      messageId: messageId,
      mode: mode
    });
  }
  if (rawText && typeof rawText === 'string' && rawText.trim()) {
    return (0, _jsxRuntime.jsx)("div", {
      className: "tw-text-[13px] tw-leading-6 tw-text-slate-700",
      style: {
        whiteSpace: 'pre-wrap'
      },
      children: rawText
    });
  }
  return (0, _jsxRuntime.jsx)(RawFallback, {
    data: data
  });
}